import Datepicker from "../../../date-picker/date-picker";

export interface IDateWidget {
  id: string;
  type: "date";
  modalType: "datamodelField"
  label: string;
  required: boolean;
  readonly: boolean;
}

interface IDateWidgetProps {
  widget: IDateWidget;
  value: string | undefined;
  onChange?(newValue: string, key?: string): void;
}
const DateWidget = ({widget, value, onChange}: IDateWidgetProps) => {
  const handleDateChange = (newValue: string) => {
    onChange?.(newValue, widget.id);
  };
  
  return <div className="dateWidget">
    <Datepicker label={widget.label} onChange={handleDateChange} required={widget.required} data={value} disabled={widget.readonly} />
  </div>;
};

export default DateWidget;
